var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('p',[_c('img',{staticStyle:{"display":"block","width":"50px","margin":"0 auto"},attrs:{"src":require("../assets/img/detail/error.svg"),"alt":""}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("error: path no found!")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf26eaae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Error.vue
// module id = ALuo
// module chunks = 9